// extracted by mini-css-extract-plugin
var _1 = "i8qcuk3c";
var _2 = "o_gYQjkL";
export { _1 as "newPostBtn", _2 as "postsSlot" }
